import {
  GET_VENDOR_EVENTS,
  GET_VENDOR_EVENTS_SUCCESS,
  GET_VENDOR_EVENTS_FAILED,
  GET_VENDOR_EVENTS_WITHOUT_FILTERS,
  GET_VENDOR_EVENTS_WITHOUT_FILTERS_SUCCESS,
  GET_VENDOR_EVENTS_WITHOUT_FILTERS_FAILED,
  REGISTER_VENDOR_EVENT,
  REGISTER_VENDOR_EVENT_SUCCESS,
  VENDOR_EVENT_NOT_REGISTERED,
  REGISTER_VENDOR_EVENT_FAILED,
  FIND_VENDOR_EVENT_REGISTERED,
  SET_VENDOR_EVENT_PAYLOAD,
  UPDATE_APPLICATION_STATUS,
  UPDATE_APPLICATION_STATUS_SUCCESS,
  UPDATE_APPLICATION_STATUS_FAILED,
  CREATE_STRIPE_CHECKOUT_SESION,
  CREATE_STRIPE_CHECKOUT_SESION_SUCCESS,
  CREATE_STRIPE_CHECKOUT_SESION_FAILED,
  SET_TOTAL_AMOUNT_DUE,
  RESET_VENDOR_EVENT,
  GET_VENDOR_EVENTS_BY_EVENT,
  GET_VENDOR_EVENTS_BY_EVENT_SUCCESS,
  GET_VENDOR_EVENTS_BY_EVENT_FAILED,
  CREATE_EVENT_APPLICATION,
  CREATE_EVENT_APPLICATION_SUCCESS,
  CREATE_EVENT_APPLICATION_FAILED,
  CANCEL_EVENT_REGISTRATION,
  CANCEL_EVENT_REGISTRATION_FAILED,
  CANCEL_EVENT_REGISTRATION_SUCCESS,
  ON_SEARCH_VENDORS_EVENT,
  GET_ALL_VENDOR_EVENTS,
  GET_ALL_VENDOR_EVENTS_SUCCESS,
  GET_ALL_VENDOR_EVENTS_FAILED,
  ON_SEARCH_ALL_VENDORS_EVENT,
  GET_REFUNDS,
  GET_REFUNDS_FAILED,
  GET_REFUNDS_SUCCESS,
  REFUND,
  REFUND_FAILED,
  REFUND_SUCCESS,
  CREATE_REFUND_REQUEST,
  CREATE_REFUND_REQUEST_FAILED,
  CREATE_REFUND_REQUEST_SUCCESS,
  GET_VENDOR_UNPAID_EVENT_REGISTRATIONS,
  GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_SUCCESS,
  GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_FAILED,
  GET_VENDOR_PAID_EVENT_REGISTRATIONS,
  GET_VENDOR_PAID_EVENT_REGISTRATIONS_SUCCESS,
  GET_VENDOR_PAID_EVENT_REGISTRATIONS_FAILED,
} from './constants';

const initialState = {
  eventList: [],
  eventListRefund: [],
  currentVendorEvent: {},
  currentStripeSession: {},
  vendorEventPayload: {
    vendor_event_contact: {},
    vendor_event_features: [],
  },
  totalAmountDue: 0,
  error: null,
  loading: false,
  refund: false,
  unpaidRegistrations: [],
  paidRegistrations: [],
};

const eventReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case RESET_VENDOR_EVENT:
      return { ...state, ...initialState };
    case REGISTER_VENDOR_EVENT:
    case GET_VENDOR_EVENTS:
    case GET_VENDOR_EVENTS_WITHOUT_FILTERS:
    case UPDATE_APPLICATION_STATUS:
    case FIND_VENDOR_EVENT_REGISTERED:
    case CREATE_STRIPE_CHECKOUT_SESION:
    case GET_VENDOR_EVENTS_BY_EVENT:
    case GET_ALL_VENDOR_EVENTS:
    case CREATE_EVENT_APPLICATION:
    case CREATE_REFUND_REQUEST:
    case CANCEL_EVENT_REGISTRATION:
    case GET_VENDOR_UNPAID_EVENT_REGISTRATIONS:
    case GET_VENDOR_PAID_EVENT_REGISTRATIONS:
      return { ...state, loading: true };
    case GET_VENDOR_EVENTS_WITHOUT_FILTERS_SUCCESS:
    case GET_VENDOR_EVENTS_SUCCESS:
    case GET_VENDOR_EVENTS_BY_EVENT_SUCCESS:
    case GET_ALL_VENDOR_EVENTS_SUCCESS:
    case CREATE_REFUND_REQUEST_SUCCESS:
      return { ...state, eventList: action.payload.events, loading: false };
    case REGISTER_VENDOR_EVENT_SUCCESS:
      return {
        ...state,
        currentVendorEvent: action.payload.data,
        vendorEventPayload: {
          ...state.vendorEventPayload,
          ...action.payload.data,
        },
        loading: false,
      };
    case GET_REFUNDS:
    case GET_REFUNDS_SUCCESS:
      return { ...state, eventListRefund: action.payload.refund, loading: false };
    case CREATE_STRIPE_CHECKOUT_SESION_SUCCESS:
      return {
        ...state,
        currentStripeSession: action.payload,
        loading: false,
      };
    case SET_VENDOR_EVENT_PAYLOAD:
      return { ...state, vendorEventPayload: { ...state.vendorEventPayload, ...action.payload } };
    case SET_TOTAL_AMOUNT_DUE:
      return { ...state, totalAmountDue: action.payload.value };
    case REFUND:
      return { ...state, loading: true, refund: false };
    case REGISTER_VENDOR_EVENT_FAILED:
    case CREATE_STRIPE_CHECKOUT_SESION_FAILED:
    case UPDATE_APPLICATION_STATUS_FAILED:
    case GET_VENDOR_EVENTS_WITHOUT_FILTERS_FAILED:
    case GET_VENDOR_EVENTS_FAILED:
    case GET_VENDOR_EVENTS_BY_EVENT_FAILED:
    case GET_ALL_VENDOR_EVENTS_FAILED:
    case GET_REFUNDS_FAILED:
    case CREATE_EVENT_APPLICATION_FAILED:
    case CANCEL_EVENT_REGISTRATION_FAILED:
    case CREATE_REFUND_REQUEST_FAILED:
    case GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_FAILED:
    case GET_VENDOR_PAID_EVENT_REGISTRATIONS_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case REFUND_FAILED:
      return { ...state, error: action.payload.error, loading: false, refund: false };
    case VENDOR_EVENT_NOT_REGISTERED:
      return { ...state, currentVendorEvent: {}, loading: false };
    case REFUND_SUCCESS:
      return { ...state, error: action.payload.error, loading: false, refund: true };
    case CREATE_EVENT_APPLICATION_SUCCESS:
      return { ...state, currentVendorEvent: action.payload.vendorEvent, loading: false };
    case GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_SUCCESS:
      return { ...state, unpaidRegistrations: action.payload.registrations, loading: false };
    case GET_VENDOR_PAID_EVENT_REGISTRATIONS_SUCCESS:
      return { ...state, paidRegistrations: action.payload.registrations, loading: false };
    case UPDATE_APPLICATION_STATUS_SUCCESS:
    case CANCEL_EVENT_REGISTRATION_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { fk_event: eventId, fk_vendor: vendorId } = action.payload.cancelledEvent;
      return {
        ...state,
        loading: false,
        eventList: state.eventList.filter(
          (event) => event.fk_event !== eventId || event.fk_vendor !== vendorId,
        ),
      };
    case ON_SEARCH_VENDORS_EVENT: {
      const { text } = action.payload;
      const filteredList = [];
      let cond;
      state.eventList?.forEach((item) => {
        const { vendor, event } = item;
        const name = `{${vendor?.name.toLowerCase()} ${vendor?.last_name.toLowerCase()}}`;
        const applicationStatus = item.application_status.toLowerCase();
        const paymentStatus = item?.status.toLowerCase();
        const vendorEmail = vendor?.email.toLowerCase();
        if (paymentStatus) {
          cond =
            name?.search(text?.toLowerCase()) !== -1 ||
            applicationStatus.search(text.toLowerCase()) !== -1 ||
            paymentStatus.search(text.toLowerCase()) !== -1 ||
            vendorEmail.search(text.toLowerCase()) !== -1;
        } else {
          cond =
            name?.search(text?.toLowerCase()) !== -1 ||
            applicationStatus.search(text.toLowerCase()) !== -1 ||
            vendorEmail.search(text.toLowerCase()) !== -1;
        }

        if (cond) filteredList.push(item);
      });
      return { ...state, filteredVendorsEvent: filteredList };
    }
    case ON_SEARCH_ALL_VENDORS_EVENT: {
      const { text } = action.payload;
      const filteredList = [];
      let cond;

      state.eventList?.forEach((item) => {
        const { vendor, event } = item;
        const eventName = event.name.toLowerCase();
        const venueName = event.venue?.name.toLowerCase();
        const vendorName = `{${vendor?.name.toLowerCase()} ${vendor?.last_name.toLowerCase()}}`;
        const vendorEmail = vendor?.email.toLowerCase();
        const applicationStatus = item.application_status.toLowerCase();
        const paymentStatus = item?.status.toLowerCase();
        const eventDate = event.parameters_event?.event_date;
        if (paymentStatus) {
          cond =
            eventName.search(text?.toLowerCase()) !== -1 ||
            venueName.search(text?.toLowerCase()) !== -1 ||
            vendorName?.search(text?.toLowerCase()) !== -1 ||
            applicationStatus.search(text.toLowerCase()) !== -1 ||
            paymentStatus.search(text.toLowerCase()) !== -1 ||
            eventDate.search(text.toLowerCase()) !== -1 ||
            vendorEmail.search(text.toLowerCase()) !== -1;
        } else {
          cond =
            eventName.search(text?.toLowerCase()) !== -1 ||
            venueName.search(text?.toLowerCase()) !== -1 ||
            vendorName?.search(text?.toLowerCase()) !== -1 ||
            applicationStatus.search(text.toLowerCase()) !== -1 ||
            eventDate.search(text.toLowerCase()) !== -1 ||
            vendorEmail.search(text.toLowerCase()) !== -1;
        }

        if (cond) filteredList.push(item);
      });
      return { ...state, filteredVendorsEvent: filteredList };
    }
    default:
      return state;
  }
};

export default eventReducer;
